import {WidgetEventStruct} from '../../widget-event.struct';
import {ModalWidgetEnum, RuntimeWidgetEnum} from '../../../enums';

export class RuntimeWidgetEventStruct extends WidgetEventStruct {
  public event_runtime_widget_type: RuntimeWidgetEnum;
} // end Package
